import { ActiveFlag } from '@automata/utils/hooks';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

import { AppLoadingMessage } from 'components/AppLoadingMessage';
import { GatedContent } from 'components/GatedContent';
import { PermissionGatedContent } from 'components/PermissionGatedContent';
import useUserV2 from 'hooks/useUserV2';
import { PermissionsEnum } from 'model/User';

interface Props {
  permissionsNeeded: PermissionsEnum;
  children: ReactNode;
  unleashFlag?: ActiveFlag;
}

export const GrantAccess = ({
  children,
  unleashFlag,
  permissionsNeeded,
}: Props): JSX.Element => {
  const { data, error, isLoading } = useUserV2();
  const router = useRouter();

  if (isLoading) {
    return <AppLoadingMessage />;
  }

  if (error) {
    const returnTo = router.pathname;
    router.push(`/api/auth/logout?returnTo=${returnTo}`);

    return <></>;
  }

  return (
    <PermissionGatedContent
      permissionNeeded={permissionsNeeded}
      userPermissions={data.permissions}
    >
      <>
        {unleashFlag !== undefined ? (
          <GatedContent unleashFlag={unleashFlag}>{children}</GatedContent>
        ) : (
          children
        )}
      </>
    </PermissionGatedContent>
  );
};
